module.exports = require('./_global');


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-polyfill/~/core-js/modules/_path.js
 ** module id = 290
 ** module chunks = 0
 **/